module.exports = __webpack_public_path__ + "img/doc-vehiculo.6a216b57.svg";